/**
 * Built-in device-type icons for the map. Returns a data-URI SVG (white glyph,
 * transparent background) chosen by keywords in the device-type name. Shown on
 * the type-coloured node. A user-uploaded type image overrides this.
 */

// base64 data-URI (not ;utf8/percent — those don't render in Cytoscape's PNG export)
const G = (inner) => {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">${inner}</svg>`;
  return 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svg)));
};

const ICONS = {
  router: G('<rect x="2" y="13" width="20" height="7" rx="2"/><circle cx="6" cy="16.5" r="0.6" fill="#fff"/><circle cx="9" cy="16.5" r="0.6" fill="#fff"/><path d="M12 13V8m0 0l-3 2m3-2l3 2"/><path d="M17 6l2-2m0 0h-2m2 0v2"/>'),
  switch: G('<rect x="2" y="9" width="20" height="6" rx="1.5"/><path d="M6 15v2m4-2v2m4-2v2m4-2v2M6 9V7m4 2V7m4 2V7m4 2V7"/>'),
  server: G('<rect x="4" y="2" width="16" height="9" rx="1.5"/><rect x="4" y="13" width="16" height="9" rx="1.5"/><path d="M7 5.5h2M7 16.5h2"/><circle cx="17" cy="5.5" r="0.6" fill="#fff"/><circle cx="17" cy="16.5" r="0.6" fill="#fff"/>'),
  pc: G('<rect x="3" y="4" width="18" height="12" rx="1.5"/><path d="M8 20h8M12 16v4"/>'),
  printer: G('<path d="M6 9V3h12v6"/><rect x="4" y="9" width="16" height="7" rx="1.5"/><rect x="7" y="14" width="10" height="6"/><circle cx="17" cy="12" r="0.6" fill="#fff"/>'),
  camera: G('<path d="M2 7l5-1 1.5-2h3L13 6l7 1.5v9a1.5 1.5 0 0 1-1.5 1.5H4A2 2 0 0 1 2 16z"/><circle cx="9" cy="12" r="3.2"/>'),
  ups: G('<rect x="4" y="3" width="16" height="18" rx="2"/><path d="M13 7l-3 5h2.5l-1 4 4-6H12z"/>'),
  wifi: G('<path d="M5 12.5a10 10 0 0 1 14 0"/><path d="M8 15.5a6 6 0 0 1 8 0"/><circle cx="12" cy="18.5" r="1.1" fill="#fff"/>'),
  plc: G('<rect x="4" y="4" width="16" height="16" rx="2"/><path d="M9 4V2m6 2V2M9 22v-2m6 2v-2M4 9H2m2 6H2m20-6h-2m2 6h-2"/><rect x="9" y="9" width="6" height="6" rx="1"/>'),
  device: G('<rect x="4" y="4" width="16" height="16" rx="2"/><path d="M8 9h8M8 13h5"/>'),
};

const RULES = [
  [/(роутер|маршрут|router|gateway|шлюз|gw)/i, 'router'],
  [/(коммутатор|свитч|switch|\bsw\b|ядр)/i, 'switch'],
  [/(сервер|server|srv|nas|схд)/i, 'server'],
  [/(рабоч|компьютер|\bпк\b|workstation|\bpc\b|ноут|laptop)/i, 'pc'],
  [/(принтер|printer|мфу|сканер)/i, 'printer'],
  [/(камер|camera|\bcam\b|видео|cctv|nvr|dvr)/i, 'camera'],
  [/(ибп|\bups\b|беспереб|аккум|battery|питан)/i, 'ups'],
  [/(точк|wi-?fi|wifi|access|\bap\b|беспровод)/i, 'wifi'],
  [/(плк|\bplc\b|контроллер|асу|scada|modbus)/i, 'plc'],
];

export function ICON_FOR_TYPE(typeName) {
  const n = (typeName || '').toString();
  for (const [re, key] of RULES) if (re.test(n)) return ICONS[key];
  return ICONS.device;
}

export default ICON_FOR_TYPE;
